export class WsEspStatus{
    public Type: string = ""
    public ModuleId: string = ""
    public CurrentIpAddress: string = ""
    public LastOnline: Date = new Date()
}